import api from './api';

const getPersons = () => api.get('/persons');
const getPerson = (id) => api.get(`/persons/${id}`);
const createPerson = (data) => api.post('/persons', data);
const updatePerson = (id, data) => api.put(`/persons/${id}`, data);
const deletePerson = (id) => api.delete(`/persons/${id}`);

const personService = { getPersons, getPerson, createPerson, updatePerson, deletePerson };
export default personService;
